module.exports = __webpack_public_path__ + "img/next.6175d1a3.png";